module.exports = __webpack_public_path__ + "media/animacion_farmacogenetica.b8e656ba.webm";